import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// TODO убрать, если есть возможность поправить ошибки TS
export function objectFromEntries(arr) {
  return arr.reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    acc[key] = value;
    return acc;
  }, {});
}